import { api } from './client';

export type FeatureStatus = 'proposed' | 'approved' | 'rejected' | 'in_progress' | 'done';

export interface FeatureRequest {
  id: string;
  title: string;
  description: string;
  status: FeatureStatus;
  requester_name: string | null;
  requester_email: string | null;
  decision_comment: string | null;
  votes: number;
  voted_by_me: boolean;
  created_at: string;
  updated_at: string;
}

export const featuresApi = {
  list: () => api.get<FeatureRequest[]>('/api/v1/features').then(r => r.data),
  create: (p: { title: string; description?: string }) =>
    api.post<FeatureRequest>('/api/v1/features', p).then(r => r.data),
  vote: (id: string) =>
    api.post<FeatureRequest>(`/api/v1/features/${id}/vote`).then(r => r.data),
  decide: (id: string, status: FeatureStatus, decision_comment?: string) =>
    api.patch<FeatureRequest>(`/api/v1/features/${id}/decision`, { status, decision_comment }).then(r => r.data),
  remove: (id: string) => api.delete(`/api/v1/features/${id}`),
};

export const FEATURE_STATUS_LABEL: Record<FeatureStatus, string> = {
  proposed:    'Предложена',
  approved:    'Одобрена',
  rejected:    'Отклонена',
  in_progress: 'В разработке',
  done:        'Готово',
};

export const FEATURE_STATUS_COLOR: Record<FeatureStatus, string> = {
  proposed:    'bg-slate-800 text-slate-300 border-slate-700',
  approved:    'bg-emerald-900/30 text-emerald-300 border-emerald-800/60',
  rejected:    'bg-red-900/30 text-red-300 border-red-800/60',
  in_progress: 'bg-blue-900/30 text-blue-300 border-blue-800/60',
  done:        'bg-purple-900/30 text-purple-300 border-purple-800/60',
};
